import { ChangeDetectionStrategy, Component, ElementRef, input, viewChild } from '@angular/core';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    selector: '[ellipsis-tooltip]',
    standalone: true,
    imports: [TooltipModule],
    templateUrl: './ellipsis-tooltip.component.html',
    styleUrls: ['./ellipsis-tooltip.component.scss'],
    host: { style: 'display: contents' },
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EllipsisTooltipComponent {
    id = input<string>();
    ellipsisNumberOfRows = input<number>(1);
    disableTooltip = input<boolean>(false);
    showTooltip = input<boolean>(false);
    tooltipPosition = input<string>('top');
    tooltipDelayTime = input<number>(0);
    tooltipEscape = input<boolean>(true); //Set to false to support html tags in the content.

    readonly contentTemplate = viewChild<ElementRef | null>('contentTemplate');
    pTooltip: string | undefined = undefined;

    shouldShowTooltip(): void {
        const el = this.contentTemplate()?.nativeElement;

        this.pTooltip =
            (!this.disableTooltip() && el.offsetHeight < el.scrollHeight) || this.showTooltip()
                ? (el.textContent ?? undefined)
                : undefined;
    }
}
